import {BUSCAR_RELATORIO_ITINERARIOS} from '../../actions/types'

const initialState = undefined;

export default function reducerRelatorioItinerarios (state = {}, action = initialState) {
  switch (action.type) {
    case BUSCAR_RELATORIO_ITINERARIOS: {
      return action.payload.data;
    }


    default: {
      return state
    }
  }
}
